var React = require('react');

function LinkedinCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0h22v22H0V0zm5.638 9.144V16.5h2.337V9.144H5.638zM5.5 6.806c0 .756.55 1.307 1.306 1.307s1.307-.55 1.307-1.307c0-.756-.55-1.306-1.307-1.306-.687 0-1.306.55-1.306 1.306zm8.662 9.694h2.2v-4.537c0-2.27-1.374-3.025-2.68-3.025-1.17 0-1.995.756-2.2 1.237V9.144h-2.2V16.5h2.337v-3.919c0-1.031.687-1.581 1.375-1.581.687 0 1.168.344 1.168 1.512V16.5z","fill":"currentColor"}));
}

LinkedinCircle.defaultProps = {"fill":"none","viewBox":"0 0 22 22"};

module.exports = LinkedinCircle;

LinkedinCircle.default = LinkedinCircle;
